import { call, put } from 'redux-saga/effects'
import { ApiResponse } from 'apisauce'

import api from 'src/services/api'

import { ClientNotifyCatch } from 'src/config/bugsnag'
import findBasicApiResponseErrors from 'src/services/findBasicApiResponseErrors'
import i18n from 'src/config/i18n'
import { ResponseDataRequests } from './types'
import * as Actions from './actions'

export function* getAgencyPartners({
  payload: { options }
}: ReturnType<typeof Actions.getAgencyPartners>) {
  // const {
  //   me: { organization }
  // } = yield select((state: ApplicationState) => state)

  // const params = []

  // if (options.request_agency_ids && options.request_agency_ids.length) {
  //   params.push(`request_agency_ids=${options.request_agency_ids.join(',')}`)
  // }

  try {
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.get,
      `/agency/partners?&page_size=10&page=${options.page || 1}`
    )

    if (response.ok) {
      const { agency_partners } = response.data
      yield put(Actions.getAgencyPartnersSuccess({ agency_partners }))
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.getAgencyPartnersFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga getPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.getAgencyPartnersFailure(message))
  }
}

export function* sendAgencyPartners({
  payload: { agency_partner }
}: ReturnType<typeof Actions.sendAgencyPartners>) {
  try {
    // const {
    //   partners,
    //   me: { user }
    // } = yield select((state: ApplicationState) => state)

    const responsePayload = { agency_partner }
    const response: ApiResponse<ResponseDataRequests> = yield call(
      api.post,
      `/agency/partners`,
      responsePayload
    )

    if (response.ok) {
      yield put(Actions.sendAgencyPartnersSuccess())
      return
    }

    const message = findBasicApiResponseErrors(response)
    yield put(Actions.sendAgencyPartnersFailure(message))
  } catch (err) {
    ClientNotifyCatch('Saga sendAgencyPartners', err)
    const message = i18n.t('common.response.unexpected-error')
    yield put(Actions.sendAgencyPartnersFailure(message))
  }
}
